import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import classnames from 'classnames';

import MongoDBIcon from './MongoDBIcon/MongoDBIcon';
import RedisIcon from './RedisIcon/RedisIcon';
import ElasticsearchIcon from './ElasticsearchIcon/ElasticsearchIcon';
import PostgreSQLIcon from './PostgreSQLIcon/PostgreSQLIcon';
import CockroachDBIcon from './CockroachDBIcon/CockroachDBIcon';
import TimescaleDBIcon from './TimescaleDBIcon/TimescaleDBIcon';
import DefaultIcon from './DefaultIcon/DefaultIcon';

const IconMap = {
  mongodb: MongoDBIcon,
  redis: RedisIcon,
  elasticsearch: ElasticsearchIcon,
  postgresql: PostgreSQLIcon,
  cockroachdb: CockroachDBIcon,
  timescaledb: TimescaleDBIcon,
};

const propTypes = {
  service: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
  badgeClass: PropTypes.string,
  isAlpha: PropTypes.bool,
  status: PropTypes.string,
};

const defaultProps = {
  className: null,
  badgeClass: null,
  isAlpha: false,
  status: null,
};

export function UnstyledServiceIcon({
  service,
  className,
  classes,
  badgeClass,
  isAlpha,
  status,
  ...props
}) {
  const Icon = IconMap[service.toLowerCase()] || DefaultIcon;

  if (status && status !== 'Failed' && status !== 'Ready') {
    return (
      <Tooltip placement="top-start" classes={{ tooltip: classes.tooltipText }} title={status}>
        <Badge
          badgeContent="!"
          classes={{ badge: classnames([classes.buildingBadge, badgeClass]) }}
        >
          <Icon className={className} {...props} />
        </Badge>
      </Tooltip>
    );
  }

  if (status === 'Failed') {
    return (
      <Tooltip placement="top-start" classes={{ tooltip: classes.tooltipText }} title="Failed">
        <Badge badgeContent="!" classes={{ badge: classnames([classes.failedBadge, badgeClass]) }}>
          <Icon className={className} {...props} />
        </Badge>
      </Tooltip>
    );
  }

  return <Icon className={className} {...props} />;
}

UnstyledServiceIcon.propTypes = propTypes;
UnstyledServiceIcon.defaultProps = defaultProps;

const styles = (theme) => ({
  badge: {
    fontSize: 'unset',
    fontWeight: 'bold',
  },
  buildingBadge: {
    color: theme.customColors.white,
    fontSize: 'unset',
    fontWeight: 'bold',
    backgroundColor: theme.customColors.burntYellow,
  },
  failedBadge: {
    color: theme.customColors.white,
    fontSize: 'unset',
    fontWeight: 'bold',
    backgroundColor: theme.customColors.red,
  },
  tooltipText: {
    marginBottom: theme.spacing(1.5),
    marginLeft: theme.spacing(2.5),
    fontSize: '.857rem',
    backgroundColor: theme.customColors.mediumGrey,
  },
});

export default withStyles(styles)(UnstyledServiceIcon);
